class TransportFactSubjectsMobile {
    constructor() {
        const container = document.querySelector('.transport-fact-subjects-mobile');
        const toggler = document.querySelector('.transport-fact-subjects-mobile__toggler');
        if (container && toggler) {
            toggler.addEventListener('click', (el) => {
                if (container.classList.contains('transport-fact-subjects-mobile--open')) {
                    container.classList.remove('transport-fact-subjects-mobile--open');
                }
                else {
                    container.classList.add('transport-fact-subjects-mobile--open');
                }
            })
        }
    }
}

document.addEventListener("DOMContentLoaded", () => new TransportFactSubjectsMobile());